<template>
  <loader v-if="fetchResumePending"/>
  <v-container v-else :class="containerClass">
    <v-row v-if="!hideTitle">
      <v-col :cols="12">
        <h1>{{ $t('texts.resume') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <resume-jobs
          :fetchResumePending="fetchResumePending"
          :items="resume.jobs"
          :resumeCardsOutlined="resumeCardsOutlined"
          :hasProfileCompleted="authUser.complete"
        />
        <resume-educations
          :fetchResumePending="fetchResumePending"
          :items="resume.educations"
          :resumeCardsOutlined="resumeCardsOutlined"
        />
        <resume-languages
          :fetchResumePending="fetchResumePending"
          :items="resume.languages"
          :resumeCardsOutlined="resumeCardsOutlined"
        />
        <resume-certifications
          :fetchResumePending="fetchResumePending"
          :items="resume.certifications"
          :resumeCardsOutlined="resumeCardsOutlined"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ResumeJobs from './parts/ResumeJobs.vue';
import ResumeEducations from './parts/ResumeEducations.vue';
import ResumeLanguages from './parts/ResumeLanguages.vue';
import ResumeCertifications from './parts/ResumeCertifications.vue';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapState: mapEmployeeState, mapActions: mapEmployeeActions } = createNamespacedHelpers('employee');

export default {
  name: 'EmployeeProfileResume',
  components: {
    ResumeJobs,
    ResumeEducations,
    ResumeLanguages,
    ResumeCertifications,
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    containerClass: {
      type: String,
      default: '',
    },
    resumeCardsOutlined: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.fetchResume();
  },
  computed: {
    ...mapUserState([
      'authUser',
    ]),
    ...mapEmployeeState([
      'fetchResumePending',
      'resume',
    ]),
  },
  methods: {
    ...mapEmployeeActions([
      'fetchResume',
    ]),
  },
};
</script>
